var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import Features1 from './Features1';
import Features2 from './Features2';
import Features3 from './Features3';
import Features9 from './Features9';
import Features14 from './Features14';
import Features23 from './Features23';
import Features24 from './Features24';
import Gallery5 from './Gallery5';
import Gallery8 from './Gallery8';
import Text2 from './Text2';
import Text6 from './Text6';
import Text7 from './Text7';
import Text16 from './Text16';
import Text17 from './Text17';
import Cta1 from './Cta1';
import Cta2 from './Cta2';
import Cta4 from './Cta4';
import Cta11 from './Cta11';
import Cta14 from './Cta14';

var LandingPageRenderer = function LandingPageRenderer(props) {
  switch (props.component) {
    case 'features1':
      return React.createElement(Features1, props);

    case 'features2':
      return React.createElement(Features2, props);

    case 'features3':
      return React.createElement(Features3, props);

    case 'features9':
      return React.createElement(Features9, props);

    case 'features14':
      return React.createElement(Features14, props);

    case 'features23':
      return React.createElement(Features23, props);

    case 'features24':
      return React.createElement(Features24, props);

    case 'gallery5':
      return React.createElement(Gallery5, props);

    case 'gallery8':
      return React.createElement(Gallery8, props);

    case 'text2':
      return React.createElement(Text2, props);

    case 'text6':
      return React.createElement(Text6, props);

    case 'text7':
      return React.createElement(Text7, props);

    case 'text16':
      return React.createElement(Text16, props);

    case 'text17':
      return React.createElement(Text17, props);

    case 'cta1':
      return React.createElement(Cta1, props);

    case 'cta2':
      return React.createElement(Cta2, props);

    case 'cta4':
      return React.createElement(Cta4, props);

    case 'cta11':
      return React.createElement(Cta11, props);

    case 'cta14':
      return React.createElement(Cta14, props);

    default:
      return null;
  }
};

var LandingPage = function (_Component) {
  _inherits(LandingPage, _Component);

  function LandingPage() {
    _classCallCheck(this, LandingPage);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  LandingPage.prototype.render = function render() {
    var components = this.props.components;
    return React.createElement('div', null, components.map(function (component, index) {
      return React.createElement(LandingPageRenderer, _extends({
        key: index
      }, component));
    }));
  };

  return LandingPage;
}(Component);

export default LandingPage;